import { Typography } from "@mui/material";
import { theme } from "../../../Common/UI/styles/theme";

export default function ReleaseTwoPointFour() {
  return (
    <>
      <Typography variant="h6" className="release-title" color={theme.palette.error.main}>
        RELEASE 2.4 - April 14th, 2025
      </Typography>
      <ul>
        <li>
          Store 411 – Building Properties Tab 
          <ul>
            <li style={{ listStyleType: "circle" }}>
              <b>NEW</b> Kitchen Layout Field – identify which kitchen layout a store has: Kitchen 1.0, 2.0 or BlueSky Kitchen
            </li>
          </ul>
        </li>
      </ul>
    </>
  );
}
